<template>
  <div>
    <Head title="Create Order" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/orders">Orders</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-gray-200 rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">

          <div class="pb-4 pr-6 w-full"> PO #:<br/><br/>
            <input class="p-2 w-full" id="purchaseorder" v-model="form.purchaseorder_id" disabled="disabled" />
          </div>
          <div class="pb-4 pr-6 w-1/2"> Sold To:<br/><br/>
             <textarea :error="form.errors.soldto" rows="5" class="mb-4 ml-0 p-2 w-full bg-gray-300 " label="Sold To" v-model="form.soldto" placeholder=""></textarea>
          </div>

          <div class="pb-4 pr-6 w-1/2" id="shipto"> Ship To:  
            <input class="p-2 w-full" id="orderjobsite" v-model="form.jobsite_id" disabled="disabled" type="hidden" />

             <!--<textarea :error="form.errors.shipto" rows="5" disabled="disabled" class="mb-4 ml-0 p-2 w-full bg-gray-300" label="S\hip To" v-model="form.shipto"></textarea>-->
          </div>

          <div class="pb-4 pr-4 w-1/4">
            <div class="mb-2">Order Date: </div>
            <datepicker v-model="form.order_date" :enableTimePicker="false" autoApply :error="form.errors.order_date" class="pb-4 pr-2 " label="Order Date" />
          </div>

          <div class="pb-4 pr-4 w-1/4">
            <div class="mb-2">Projected Delivery: </div>
            <datepicker v-model="form.projected_delivery" :enableTimePicker="false" autoApply :error="form.errors.projected_delivery" class="pb-4 pr-2" label="Projected Delivery"/>
          </div>

          <div class="pb-4 pr-4 w-1/4">
            <div class="mb-2">Cutoff Date: </div>
            <datepicker v-model="form.cutoff_date" :enableTimePicker="false" autoApply :error="form.errors.cutoff_date" class="pb-4 pr-2" label="Cutoff Date" />
          </div>

          <div class="pb-4 pr-4 w-1/4">
            <div class="mb-2">Actual Delivery: </div>
            <datepicker v-model="form.actual_delivery" :enableTimePicker="false" autoApply :error="form.errors.actual_delivery" class="pb-4 pr-2" label="Actual Delivery"/>
          </div>
          <div class="w-full"></div>
          
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-4 pr-6 w-1/2" label="Phone" placeholder="(254) 111-1111" />
          <text-input v-model="form.payment_terms" :error="form.errors.payment_terms" class="pb-4 pr-6 w-full lg:w-1/2" label="Payment Terms" placeholder="NET30" />
          <text-input v-model="form.trader" :error="form.errors.trader" class="pb-4 pr-6 w-full lg:w-1/2" label="Trader" placeholder="" />
          <text-input v-model="form.fob" :error="form.errors.fob" class="pb-4 pr-6 w-full lg:w-1/2" label="F.O.B." placeholder="Jobsite" />
          <text-input v-model="form.routing" :error="form.errors.routing" class="pb-4 pr-6 w-full lg:w-1/2" label="Routing" placeholder="Truck" />
          <text-input v-model="form.bid_id" :error="form.errors.bid_id" class="pb-4 pr-6 w-full lg:w-1/2" label="Bid ID" placeholder="" />
          <input type="hidden" id="vendorfield" v-model="form.vendor" :error="form.errors.bid_id" />

        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Order</loading-button>
        </div>
      </form>
    </div>
  </div>
  <button id="updatejobsite"></button>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { TabulatorFull as Tabulator } from 'tabulator-tables'  
//import Vue3Signature from "vue3-signature"
//import { table } from 'console'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Datepicker,
    Tabulator,
  },
  layout: Layout,
  props: {
    filters: Object,
    jobsites: Object,
    auth: Object,
    purchaseorders: Object,
  },
  remember: 'form, tabledata',
  data() {
    return {
      form: this.$inertia.form({
        sitename: null,
        phone: null,
        soldto: null,
        shipto: null,
        jobsite_id: null,
        order_date: null,
        purchaseorder_id: this.getpo(),
        projected_delivery: null,
        cutoff_date: null,
        actual_delivery: null,
        payment_terms: null,
        trader: null,
        fob: null,
        routing: null,
        bid_id: null,
        signature: null,
        products: null,
        vendor: this.getVendor(),
      }),
      tabledata: null,
    }
  },
  methods: {
    getVendor() {
      var vend;
      var formpo = this.getpo();
      this.purchaseorders.data.forEach(function(v,k) {
        if (v.id == formpo) {
          vend = v.vendor;
        }
      });
      //document.querySelector('#vendorfield').value = vend;
      return vend;
    },
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    store() {
      this.form.post('/orders')
    },
    getjobsite() {
      var jsid =  window.location.search.split('js=')[1].split('&')[0];
      this.form.jobsite_id = jsid;
      var shiptotext = document.querySelector('#jobsiteselector').options.selectedIndex;
      
    },
    getpo() {
      var po = window.location.search.split('po=')[1].split('&')[0];
      //this.form.purchaseorder_id = po;
      return po;
    },
  },
  mounted() {
    this.getjobsite();
    this.getpo();
    this.getVendor();
  },
  computed: {
    products: function() {
      return table.getData();
    }
  },  
}
</script>

<script setup>
/*
import {reactive, ref} from 'vue'

const state = reactive({
  count: 0,
  option: {
    penColor: "rgb(0, 0, 0)",
    backgroundColor: "rgb(242,242,242)"
  },
  disabled: false
})

const signature1 = ref(null)

const save = (t) => {
  event.preventDefault();
  console.log(signature1.value.save(t))
}

const clear = () => {
  event.preventDefault();
  signature1.value.clear()
}

const undo = () => {
  signature1.value.undo();
}

const addWaterMark = () => {
  signature1.value.addWaterMark({
    text: "mark text",          // watermark text, > default ''
    font: "20px Arial",         // mark font, > default '20px sans-serif'
    style: 'all',               // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
    fillStyle: "red",           // fillcolor, > default '#333'
    strokeStyle: "blue",	       // strokecolor, > default '#333'
    x: 100,                     // fill positionX, > default 20
    y: 200,                     // fill positionY, > default 20
    sx: 100,                    // stroke positionX, > default 40
    sy: 200                     // stroke positionY, > default 40
  });
}

const fromDataURL = (url) => {
  signature1.value.fromDataURL("https://avatars2.githubusercontent.com/u/17644818?s=460&v=4");
}

const handleDisabled = () => {
  state.disabled = !state.disabled
}
*/
var tabledata = [
/*  {
      quantity:82923,
      unit:"PCS",
      sizet:"2",
      sizew:"4",
      sizel:"10'",
      itemdesc:"116-5/8 #2 SYP",
      totalqty:552847,
      totalunit:"BF",
      itemcategory:"PET STUDS"
    },
    {
      quantity:3381,
      unit:"PCS",
      sizet:"2",
      sizew:"6",
      sizel:"10'",
      itemdesc:"116-5/8 #2 SYP",
      totalqty:33810,
      totalunit:"BF",
      itemcategory:"PET STUDS"
    },
    {
      quantity:39,
      unit:"rolls",
      sizet:null,
      sizew:null,
      sizel:null,
      itemdesc:"6\" Sill Sealer",
      totalqty:null,
      totalunit:null,
      itemcategory:"MISC ITEMS"
    },
*/
];

var addRow = () => {
  event.preventDefault();
  tabledata.push({id:tabledata.length+1,item:'', price:0, quantity:0, unit: ''});
};
/*
window.setTimeout(function() { 
var table = new Tabulator("#orderstable", {
  reactiveData:true, //enable reactive data
  data:tabledata,
  columns:[
    {title:"id",field:"id",formatter:"rownum"},  
    {title:"Quantity",field:"quantity",editor:"number",editorParams:{min:0,max:9999999999,step:1}},
    {title:"Unit",field:"unit",editor:"input"},
    {title:"T",field:"sizet",editor:"input"},
    {title:"W",field:"sizew",editor:"input"},
    {title:"L",field:"sizel",editor:"input"},
    {title:"Item",field:"itemdesc",editor:"input"},
    {title:"Total Qty",field:"totalqty",editor:"number",editorParams:{min:0,max:9999999999,step:1}},
    {title:"Total Unit",field:"totalunit",editor:"input"},
    {title:"Category",field:"itemcategory",editor:"input"},
    {title:"Price",field:"price",editor:"number",editorParams:{min:0,max:9999999999,step:0.01},formatter:"money",formatterParams:{decimal:".",thousand:",",symbol:"$",symbolAfter:"",precision:false}},
    {title:"",formatter:"buttonCross", width:40, editable:true, editor:true, headerSort:false, hozAlign:"center", cellClick:function(e, cell){window.setTimeout(function() { cell.getRow().delete(); },5); }},
  ]  
});}, 500);
*/

//table.addRow({item:'', price:0, quantity:0, unit: ''});
</script>

<style scoped>
.example{
  margin: 0 auto;
}
</style>